import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import { FilterMode } from "./types";
import { FILTER_MODE } from "./constants";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface ConditionSelectFilterProps {
  value?: FilterMode;
  onChange: (value: FilterMode) => void;
  id?: string;
}

export const ConditionSelectFilter: React.FC<ConditionSelectFilterProps> = ({
  value = FILTER_MODE.ANY,
  onChange,
  id = "condition-button-menu-filter",
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (selectedValue: FilterMode) => {
    onChange(selectedValue);
    handleClose();
  };

  return (
    <Stack id={id}>
      <Button
        id={`${id}-button`}
        aria-controls={open ? `${id}-menu` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="text"
        endIcon={<KeyboardArrowDownIcon />}
        size="small"
        sx={{
          textTransform: "lowercase",
          paddingLeft: "6px",
          paddingRight: "2px",
          minWidth: "auto",
          lineHeight: "unset",
          "& .MuiButton-endIcon": {
            marginLeft: "2px",
          },
        }}
      >
        {value === FILTER_MODE.ANY ? "any" : "all"}
      </Button>
      <Menu
        id={`${id}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `${id}-button`,
        }}
      >
        <MenuItem
          id={`${id}-any-item`}
          onClick={() => handleMenuItemClick(FILTER_MODE.ANY)}
          selected={value === FILTER_MODE.ANY}
        >
          any
        </MenuItem>
        <MenuItem
          id={`${id}-all-item`}
          onClick={() => handleMenuItemClick(FILTER_MODE.ALL)}
          selected={value === FILTER_MODE.ALL}
        >
          all
        </MenuItem>
      </Menu>
    </Stack>
  );
};
